import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {Result} from "@domain/common/http/result";
import {HttpClient} from "@angular/common/http";
import {environment} from "@environments/environment";
import {PasswordParams} from "@domain/admin/parametre/authentification/generalites/password-params";

/**
 * Service de gestion des appels pour Généralités
 *
 * @author Lionel Gimenez
 * @date 25/07/2025
 */
@Injectable({
    providedIn: "root",
})
export class GeneralitesHttpService {
    constructor(private http: HttpClient) {
    }

    /**
     * Charge le PasswordParams
     */
    loadListePasswordParams(): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/PasswordParams/getListe`,null);
    }

    /**
     * Sauvegarde le PasswordParams
     */
    savePasswordParams(passwordParams: PasswordParams): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/PasswordParams/save`,passwordParams);
    }
}